module.exports = __webpack_public_path__ + "static/media/YF55_2.b42f58fd.jpg";